import { Reel } from '../../models';

export const isSelectedFunction = (
  selectedReels: Reel[],
  item: Reel
): boolean => selectedReels.map(({ id }) => id).includes(item.id);

export const isDisabledFunction = (item: Reel): boolean => !!item.packageLength;
